import ionicCoreGlobalScript from '/app/node_modules/@ionic/core/dist/collection/global/ionic-global.js';
import stencilLibraryGlobalScript from '/app/packages/stencil-library/src/global/app.ts';
export const globalScripts = () => {
  return Promise.all([
    stencilLibraryGlobalScript(),
    ionicCoreGlobalScript(),
  ]);
};
